export const disableBrowserScroll = () => {
  window.onscroll = () => {
    window.scrollTo(0, 0)
  }
}

export const addOverflowHiddenToBody = () => {
  document.getElementsByTagName('body')[0].style.overflow = 'hidden'
}

export const getViewportSize = () => {
  let width = window.innerWidth
  let height = window.innerHeight

  // Fallback 1: documentElement size
  if (!width || !height) {
    width = document.documentElement.clientWidth
    height = document.documentElement.clientHeight
  }

  // Fallback 2: screen size
  if (!width || !height) {
    width = window.screen.width
    height = window.screen.height
  }

  return { width, height }
}
